import { Button, Spacer } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useClipSelect } from '../ClipSelectContext';
import { useClipSelectTracking } from '../ClipSelectTrackingContext';
import ClipSelectActions from './ClipSelectActions';
import { useClipSelectDetailCardContext } from './ClipSelectDetailCardContext';
import { detailViewControlsIsDisabledSelector } from './selectors';
import { editPanelBlock as block } from './utils';

export type ClipSelectDetailControlsProps = {
  onAdvancedEditor: () => void;
  onSubmit: () => void;
};

const ClipSelectDetailControls: React.FC<ClipSelectDetailControlsProps> = ({
  onAdvancedEditor,
  onSubmit,
}) => {
  const {
    isInitialized,
    suggestionId: clipId,
  } = useClipSelectDetailCardContext();

  const { suggestion } = useClipSelect({
    clipId,
  });

  const {
    onOpenInAdvancedEditor: trackOnOpenInAdvancedEditor,
  } = useClipSelectTracking();

  const isControlsDisabled = detailViewControlsIsDisabledSelector(suggestion, {
    isInitialized,
  });

  const handleAdvancedEditor = useCallback(() => {
    trackOnOpenInAdvancedEditor();
    onAdvancedEditor();
  }, [onAdvancedEditor, trackOnOpenInAdvancedEditor]);

  return (
    <Spacer
      align="center"
      justify="center"
      orientation="horizontal"
      className={block('controls')}
      space="16px"
    >
      <ClipSelectActions
        clipId={clipId}
        clipName={suggestion.projectName}
        isDisabled={isControlsDisabled}
        onEdit={handleAdvancedEditor}
      />
      <Button
        color="primary"
        variant="special"
        className={block('controls-share-button')}
        onPress={onSubmit}
        isDisabled={isControlsDisabled}
      >
        Export
      </Button>
    </Spacer>
  );
};

export default ClipSelectDetailControls;
